import { ComparatorStep } from '@kizi/comparator-core';

import { defaultFiltersTriplePlay } from '../../../components';

const shouldSkipErrors = () => {
  const searchParams = new URLSearchParams(location.search);
  return searchParams.get('affiliateUrl') !== null;
};

const overview: ComparatorStep = {
  path: 'overview',
  name: 'overview',
  skipPreviousFieldErrors: shouldSkipErrors(),
  fields: [
    {
      name: 'requestLogId',
    },
    {
      name: 'selectedProduct',
      validator: 'required',
    },
    { name: 'monthlyCosts', value: '[]' },
    { name: 'onceOffCosts', value: '[]' },
    {
      name: 'comparisonProducts',
    },
    {
      name: 'apiProducts',
    },
    {
      name: 'comparisonId',
      value: '',
    },
    {
      name: 'specificTvChannelOptions',
    },
    {
      name: 'mobileProvider',
      value: JSON.stringify([]),
    },
    {
      name: 'energySupplier',
      value: JSON.stringify([]),
    },
    {
      name: 'additionalChannels',
      value: JSON.stringify([]),
    },
    {
      name: 'productTypes',
      active: true,
      label: 'Welk pakket wil je vergelijken?',
      value: JSON.stringify(['internet']),
    },
    {
      name: 'filters',
      value: JSON.stringify({
        showPriceMode: ['month'],
        productTypes: ['internet'],
        monthlyPrice: [0, 150],
        suppliers: [],
        downloadSpeed: [50, 8000],
        signal: ['DSL', 'Kabel', 'Glasvezel', '5G'],
        extraOptions: [],
        duration: ['12'],
        numberPorting: [],
        unlimitedCallingInNetherlands: [],
        unlimitedCallingInEurope: [],
      }),
    },
    {
      name: 'defaultFilters',
      value: JSON.stringify({
        showPriceMode: ['month'],
        productTypes: ['internet'],
        monthlyPrice: [0, 150],
        suppliers: [],
        downloadSpeed: [50, 8000],
        signal: ['DSL', 'Kabel', 'Glasvezel', '5G'],
        extraOptions: [],
        duration: ['12'],
        numberPorting: [],
        unlimitedCallingInNetherlands: [],
        unlimitedCallingInEurope: [],
      }),
    },
    {
      name: 'filterGraphQL',
      value: JSON.stringify(defaultFiltersTriplePlay),
    },
    {
      name: 'isLoadingProducts',
      value: 'true',
    },
  ],
};

export default overview;
